export enum AdminUserType {
    ADMIN = 'admin',
    SUPER_ADMIN = 'super_admin',
}

/** String values match GraphQL `UserType` so admin list filters need no conversion layer. */
export enum UserType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
